import React from 'react';
import { Marker, Tooltip } from 'react-leaflet';
import L from 'leaflet';

// EXACT same JSX from original Onde.jsx - NO CHANGES to layout/design/logic
const TrafficLightMarkers = ({
  trafficLights,
  selectedTraffic,
  setSelectedTraffic,
  manualSelect,
  setSelectedSign,
  setShowSelectionPopup,
  activeSignals = [],
  animationActive = false,
  setShowSelectedCard,
  messageApi
}) => {
  if (!trafficLights || trafficLights.length === 0) {
    return null;
  }

  // Filter out duplicates by id to prevent markers with same id
  const uniqueTrafficLights = trafficLights.filter((light, index, self) => {
    // Keep the first occurrence of each id
    return index === self.findIndex(t => t.id === light.id);
  });

  return (
    <>
      {uniqueTrafficLights.map((light, index) => {
        const lat = light.lat || light.latitude;
        const lng = light.lng || light.longitude;

        if (!lat || !lng) return null;

        const isSelected = selectedTraffic.some(t => t.id === light.id);
        const selectedIndex = selectedTraffic.findIndex(t => t.id === light.id);
        const isManual = light.isManual || (light.id && String(light.id).startsWith('manual-'));

        // Get traffic light data for tooltip
        const selectedData = selectedTraffic.find(t => t.id === light.id);
        const displayName = selectedData?.nome || light.name || light.id || `Semaforo ${index + 1}`;
        const distance = selectedData?.distanza;
        const durataVerde = selectedData?.durata_verde;
        const lunghezzaAttraversamento = selectedData?.lunghezza_attraversamento;

        // Check if this marker is active during animation (car is passing)
        // Match by id, nome, name, or index since the animation uses multiple identifiers
        const signalId = selectedData?.id || light.id;
        const signalName = selectedData?.nome || light.name;
        // Get the index of this marker in selectedTraffic (matches result.risultati order)
        const signalIndex = selectedTraffic.findIndex(t => t.id === light.id);
        const indexIdentifier = signalIndex >= 0 ? `signal-index-${signalIndex}` : null;

        const isActiveInAnimation = animationActive && isSelected && (
          activeSignals.includes(signalId) ||
          activeSignals.includes(signalName) ||
          (indexIdentifier && activeSignals.includes(indexIdentifier))
        );

        // Determine marker color based on state
        let markerColor, borderColor;
        if (isSelected) {
          if (animationActive) {
            // During animation: green when active (car passing), red when not
            markerColor = isActiveInAnimation ? '#A1E430' : '#FF4444';
            borderColor = isActiveInAnimation ? '#7BC320' : '#CC0000';
          } else {
            // Not animating: blue for selected
            markerColor = '#4A90D9';
            borderColor = '#2E6BB0';
          }
        } else if (isManual) {
          markerColor = '#FFA500';
          borderColor = '#FF8C00';
        } else {
          markerColor = '#FF4444';
          borderColor = '#CC0000';
        }

        return (
          <Marker
            key={`traffic-light-${light.id}-${isActiveInAnimation}-${animationActive}-${isSelected}`}
            position={[lat, lng]}
            icon={L.divIcon({
              html: `
                <div style="
                  width: 20px;
                  height: 20px;
                  background: ${markerColor};
                  border: 2px solid ${borderColor};
                  border-radius: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  color: white;
                  font-weight: bold;
                  font-size: 12px;
                  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
                  cursor: ${manualSelect ? 'pointer' : 'default'};
                ">
                  ${isSelected ? selectedIndex + 1 : ''}
                </div>
              `,
              className: 'custom-traffic-marker',
              iconSize: [20, 20],
              iconAnchor: [10, 10]
            })}
            eventHandlers={{
              click: () => {
                if (manualSelect && !isSelected) {
                  // Directly add to selection with default values (no popup)
                  const newTraffic = {
                    ...light,
                    nome: light.name || light.id || `Semaforo ${selectedTraffic.length + 1}`,
                    distanza: 100,
                    durata_verde: 20,
                    lunghezza_attraversamento: 10,
                    configured: true
                  };

                  setSelectedTraffic(prev => [...prev, newTraffic]);

                  // Show the selected card if it was hidden
                  if (setShowSelectedCard) setShowSelectedCard(true);

                  // Show success message
                  if (messageApi) {
                    messageApi.success(`Semaforo "${newTraffic.nome}" aggiunto alla selezione`);
                  }
                }
              }
            }}
          >
            <Tooltip
              direction="top"
              offset={[0, -10]}
              opacity={0.95}
              className="traffic-light-tooltip"
            >
              <div style={{
                padding: '4px 0',
                minWidth: '140px'
              }}>
                <div style={{
                  fontWeight: 600,
                  fontSize: '13px',
                  marginBottom: '6px',
                  color: '#1a1a1a',
                  borderBottom: '1px solid #eee',
                  paddingBottom: '4px'
                }}>
                  {displayName}
                </div>
                {isManual && (
                  <div style={{ fontSize: '11px', color: '#FFA500', marginBottom: '4px' }}>
                    📍 Punto manuale
                  </div>
                )}
                {distance !== undefined && (
                  <div style={{ fontSize: '12px', color: '#666' }}>
                    <strong>Distanza:</strong> {distance} m
                  </div>
                )}
                {durataVerde !== undefined && (
                  <div style={{ fontSize: '12px', color: '#666' }}>
                    <strong>Durata verde:</strong> {durataVerde} s
                  </div>
                )}
                {lunghezzaAttraversamento !== undefined && (
                  <div style={{ fontSize: '12px', color: '#666' }}>
                    <strong>Lungh. attrav.:</strong> {lunghezzaAttraversamento} m
                  </div>
                )}
                {!isSelected && (
                  <div style={{
                    fontSize: '11px',
                    color: '#999',
                    marginTop: '6px',
                    fontStyle: 'italic'
                  }}>
                    {manualSelect ? 'Clicca per selezionare' : 'Attiva selezione per configurare'}
                  </div>
                )}
              </div>
            </Tooltip>
          </Marker>
        );
      })}
    </>
  );
};

export default TrafficLightMarkers;